/**
 * Video Grid — modal video player.
 *
 * Each video-grid block ships its own modal (`#videoGridModal-…`). When a
 * thumbnail button is clicked Bootstrap opens the modal; we listen for the
 * `show.bs.modal` event, read `data-video-id` from the triggering button, and
 * set the iframe `src` to a YouTube embed with autoplay. On close, the src is
 * cleared so playback stops.
 */
(function () {
    function initVideoGrid(context) {
        var root = context || document;
        var modals = root.querySelectorAll('.video-grid__modal');

        modals.forEach(function (modalEl) {
            if (modalEl.dataset.videoGridBound === '1') return;
            modalEl.dataset.videoGridBound = '1';

            var iframe = modalEl.querySelector('.video-grid__modal-iframe');
            if (!iframe) return;

            modalEl.addEventListener('show.bs.modal', function (event) {
                var trigger = event.relatedTarget;
                if (!trigger) return;
                var videoId = trigger.getAttribute('data-video-id');
                if (!videoId) return;
                iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0';
            });

            modalEl.addEventListener('hidden.bs.modal', function () {
                // Clearing src kills the player → audio + video stop cleanly.
                iframe.src = '';
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initVideoGrid(); });
    } else {
        initVideoGrid();
    }

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=video-grid', function ($block) {
            if ($block && $block[0]) initVideoGrid($block[0]);
        });
    }
})();
